// extracted by mini-css-extract-plugin
export default {"tab-container":"styles_tab-container__ZTZNI","custom-table-style":"styles_custom-table-style__grDos","result-count":"styles_result-count__lY2BY"};